var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { hasMany, belongsTo, attr } from '@ember-data/model';
import { TrackedAsyncData } from 'ember-async-data';
import { cached } from '@glimmer/tracking';
import { mapBy, uniqueValues } from 'ilios-common/utils/array-helpers';
let User = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('boolean'), _dec10 = attr('boolean'), _dec11 = attr('string'), _dec12 = attr('string'), _dec13 = attr('boolean'), _dec14 = attr('boolean'), _dec15 = attr('string'), _dec16 = attr('boolean'), _dec17 = hasMany('report', {
  async: true,
  inverse: 'user'
}), _dec18 = belongsTo('school', {
  async: true,
  inverse: null
}), _dec19 = belongsTo('authentication', {
  async: true,
  inverse: 'user'
}), _dec20 = hasMany('course', {
  async: true,
  inverse: 'directors'
}), _dec21 = hasMany('course', {
  async: true,
  inverse: 'administrators'
}), _dec22 = hasMany('course', {
  async: true,
  inverse: 'studentAdvisors'
}), _dec23 = hasMany('session', {
  async: true,
  inverse: 'studentAdvisors'
}), _dec24 = hasMany('learner-group', {
  async: true,
  inverse: 'users'
}), _dec25 = hasMany('learner-group', {
  async: true,
  inverse: 'instructors'
}), _dec26 = hasMany('instructor-group', {
  async: true,
  inverse: 'users'
}), _dec27 = hasMany('ilm-session', {
  async: true,
  inverse: 'instructors'
}), _dec28 = hasMany('ilm-session', {
  async: true,
  inverse: 'learners'
}), _dec29 = hasMany('offering', {
  async: true,
  inverse: 'learners'
}), _dec30 = hasMany('offering', {
  async: true,
  inverse: 'instructors'
}), _dec31 = hasMany('program-year', {
  async: true,
  inverse: 'directors'
}), _dec32 = hasMany('user-role', {
  async: true,
  inverse: null
}), _dec33 = hasMany('school', {
  async: true,
  inverse: 'directors'
}), _dec34 = hasMany('school', {
  async: true,
  inverse: 'administrators'
}), _dec35 = hasMany('session', {
  async: true,
  inverse: 'administrators'
}), _dec36 = hasMany('program', {
  async: true,
  inverse: 'directors'
}), _dec37 = hasMany('cohort', {
  async: true,
  inverse: 'users'
}), _dec38 = belongsTo('cohort', {
  async: true,
  inverse: null
}), _dec39 = hasMany('pending-user-update', {
  async: true,
  inverse: 'user'
}), _dec40 = hasMany('curriculum-inventory-report', {
  async: true,
  inverse: 'administrators'
}), _dec41 = hasMany('user-session-material-status', {
  async: true,
  inverse: 'user'
}), _class = class User extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "lastName", _descriptor, this);
    _initializerDefineProperty(this, "firstName", _descriptor2, this);
    _initializerDefineProperty(this, "middleName", _descriptor3, this);
    _initializerDefineProperty(this, "displayName", _descriptor4, this);
    _initializerDefineProperty(this, "pronouns", _descriptor5, this);
    _initializerDefineProperty(this, "phone", _descriptor6, this);
    _initializerDefineProperty(this, "email", _descriptor7, this);
    _initializerDefineProperty(this, "preferredEmail", _descriptor8, this);
    _initializerDefineProperty(this, "addedViaIlios", _descriptor9, this);
    _initializerDefineProperty(this, "enabled", _descriptor10, this);
    _initializerDefineProperty(this, "campusId", _descriptor11, this);
    _initializerDefineProperty(this, "otherId", _descriptor12, this);
    _initializerDefineProperty(this, "examined", _descriptor13, this);
    _initializerDefineProperty(this, "userSyncIgnore", _descriptor14, this);
    _initializerDefineProperty(this, "icsFeedKey", _descriptor15, this);
    _initializerDefineProperty(this, "root", _descriptor16, this);
    _initializerDefineProperty(this, "reports", _descriptor17, this);
    _initializerDefineProperty(this, "school", _descriptor18, this);
    _initializerDefineProperty(this, "authentication", _descriptor19, this);
    _initializerDefineProperty(this, "directedCourses", _descriptor20, this);
    _initializerDefineProperty(this, "administeredCourses", _descriptor21, this);
    _initializerDefineProperty(this, "studentAdvisedCourses", _descriptor22, this);
    _initializerDefineProperty(this, "studentAdvisedSessions", _descriptor23, this);
    _initializerDefineProperty(this, "learnerGroups", _descriptor24, this);
    _initializerDefineProperty(this, "instructedLearnerGroups", _descriptor25, this);
    _initializerDefineProperty(this, "instructorGroups", _descriptor26, this);
    _initializerDefineProperty(this, "instructorIlmSessions", _descriptor27, this);
    _initializerDefineProperty(this, "learnerIlmSessions", _descriptor28, this);
    _initializerDefineProperty(this, "offerings", _descriptor29, this);
    _initializerDefineProperty(this, "instructedOfferings", _descriptor30, this);
    _initializerDefineProperty(this, "programYears", _descriptor31, this);
    _initializerDefineProperty(this, "roles", _descriptor32, this);
    _initializerDefineProperty(this, "directedSchools", _descriptor33, this);
    _initializerDefineProperty(this, "administeredSchools", _descriptor34, this);
    _initializerDefineProperty(this, "administeredSessions", _descriptor35, this);
    _initializerDefineProperty(this, "directedPrograms", _descriptor36, this);
    _initializerDefineProperty(this, "cohorts", _descriptor37, this);
    _initializerDefineProperty(this, "primaryCohort", _descriptor38, this);
    _initializerDefineProperty(this, "pendingUserUpdates", _descriptor39, this);
    _initializerDefineProperty(this, "administeredCurriculumInventoryReports", _descriptor40, this);
    _initializerDefineProperty(this, "sessionMaterialStatuses", _descriptor41, this);
  }
  get _rolesData() {
    return new TrackedAsyncData(this.roles);
  }
  get _cohortsData() {
    return new TrackedAsyncData(this.cohorts);
  }
  get _offeringsData() {
    return new TrackedAsyncData(this.offerings);
  }
  get _learnerIlmSessionsData() {
    return new TrackedAsyncData(this.learnerIlmSessions);
  }
  get _directedCoursesData() {
    return new TrackedAsyncData(this.directedCourses);
  }
  get _administeredCoursesData() {
    return new TrackedAsyncData(this.administeredCourses);
  }
  get _administeredSessionsData() {
    return new TrackedAsyncData(this.administeredSessions);
  }
  get _instructorGroupsData() {
    return new TrackedAsyncData(this.instructorGroups);
  }
  get _instructedOfferingsData() {
    return new TrackedAsyncData(this.instructedOfferings);
  }
  get _instructedLearnerGroupsData() {
    return new TrackedAsyncData(this.instructedLearnerGroups);
  }
  get _directedProgramsData() {
    return new TrackedAsyncData(this.directedPrograms);
  }
  get _programYearsData() {
    return new TrackedAsyncData(this.programYears);
  }
  get _administeredCurriculumInventoryReportsData() {
    return new TrackedAsyncData(this.administeredCurriculumInventoryReports);
  }
  get _directedSchoolsData() {
    return new TrackedAsyncData(this.directedSchools);
  }
  get _administeredSchoolsData() {
    return new TrackedAsyncData(this.administeredSchools);
  }
  get _instructorIlmSessionsData() {
    return new TrackedAsyncData(this.instructorIlmSessions);
  }
  get _primaryCohortData() {
    return new TrackedAsyncData(this.primaryCohort);
  }
  get _roleTitles() {
    if (!this._rolesData.isResolved) {
      return [];
    }
    return this._rolesData.value.map(r => r.title);
  }
  get _learnerGroupsData() {
    return new TrackedAsyncData(this.learnerGroups);
  }
  get isStudent() {
    return Boolean(this._roleTitles.includes('Student'));
  }

  /**
   * Checks if a user is linked to any student things
   */
  get isLearner() {
    if (this._cohortsData.isResolved && this._cohortsData.value.length) {
      return true;
    }
    if (this._offeringsData.isResolved && this._offeringsData.value.length) {
      return true;
    }
    if (this._learnerIlmSessionSessionsData?.isResolved && this._learnerIlmSessionSessionsData.value.length) {
      return true;
    }
    return false;
  }

  /**
   * Checks if a user is linked to any non-student things
   */
  get performsNonLearnerFunction() {
    if (this._directedCoursesData.isResolved && this._directedCoursesData.value.length) {
      return true;
    }
    if (this._administeredCoursesData.isResolved && this._administeredCoursesData.value.length) {
      return true;
    }
    if (this._administeredSessionsData.isResolved && this._administeredSessionsData.value.length) {
      return true;
    }
    if (this._instructorGroupsData.isResolved && this._instructorGroupsData.value.length) {
      return true;
    }
    if (this._instructedOfferingsData.isResolved && this._instructedOfferingsData.value.length) {
      return true;
    }
    if (this._instructorIlmSessionsData.isResolved && this._instructorIlmSessionsData.value.length) {
      return true;
    }
    if (this._instructedLearnerGroupsData.isResolved && this._instructedLearnerGroupsData.value.length) {
      return true;
    }
    if (this._directedProgramsData.isResolved && this._directedProgramsData.value.length) {
      return true;
    }
    if (this._programYearsData.isResolved && this._programYearsData.value.length) {
      return true;
    }
    if (this._administeredCurriculumInventoryReportsData.isResolved && this._administeredCurriculumInventoryReportsData.value.length) {
      return true;
    }
    if (this._directedSchoolsData.isResolved && this._directedSchoolsData.value.length) {
      return true;
    }
    if (this._administeredSchoolsData.isResolved && this._administeredSchoolsData.value.length) {
      return true;
    }
    return false;
  }
  get fullName() {
    return this.displayName ? this.displayName : this.fullNameFromFirstMiddleInitialLastName;
  }
  get fullNameFromFirstMiddleInitialLastName() {
    if (!this.firstName || !this.lastName) {
      return '';
    }
    const middleInitial = this.middleName ? this.middleName.charAt(0) : false;
    if (middleInitial) {
      return `${this.firstName} ${middleInitial}. ${this.lastName}`;
    } else {
      return `${this.firstName} ${this.lastName}`;
    }
  }
  get fullNameFromFirstMiddleLastName() {
    if (!this.firstName || !this.lastName) {
      return '';
    }
    if (this.middleName) {
      return `${this.firstName} ${this.middleName} ${this.lastName}`;
    } else {
      return `${this.firstName} ${this.lastName}`;
    }
  }
  get fullNameFromFirstLastName() {
    if (!this.firstName || !this.lastName) {
      return '';
    }
    return `${this.firstName} ${this.lastName}`;
  }
  get hasDifferentDisplayName() {
    const displayName = this.displayName?.trim().toLowerCase();
    // no display name? nothing to compare then.
    if (!displayName) {
      return false;
    }
    // compare the display name to 'first last', then to 'first middle last' and 'first m. last' as a fallbacks.
    return !(displayName === this.fullNameFromFirstLastName.trim().toLowerCase() || displayName === this.fullNameFromFirstMiddleLastName.trim().toLowerCase() || displayName === this.fullNameFromFirstMiddleInitialLastName.trim().toLowerCase());
  }
  get _instructedLearnerGroupOfferingsData() {
    if (!this._instructedLearnerGroupsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._instructedLearnerGroupsData.value.map(t => t.offerings)));
  }
  get _allInstructedOfferings() {
    if (!this._instructedLearnerGroupOfferingsData?.isResolved || !this._instructorGroupOfferings?.isResolved || !this._instructedOfferingsData.isResolved) {
      return [];
    }
    return uniqueValues([...this._instructedLearnerGroupOfferingsData.value.flat(), ...this._instructorGroupOfferings.value.flat(), ...this._instructedOfferingsData.value]);
  }
  get _allInstructedOfferingSessions() {
    return new TrackedAsyncData(Promise.all(this._allInstructedOfferings.map(o => o.session)));
  }
  get _instructorIlmSessionSessions() {
    if (!this._instructorIlmSessionsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._instructorIlmSessionsData.value.map(t => t.session)));
  }
  get _instructorGroupIlmSessions() {
    if (!this._instructorGroupsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._instructorGroupsData.value.map(i => i.ilmSessions)));
  }
  get _instructorGroupIlmSessionSessions() {
    if (!this._instructorGroupIlmSessions?.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._instructorGroupIlmSessions.value.flat().map(ilm => ilm.session)));
  }
  get _instructorGroupOfferings() {
    if (!this._instructorGroupsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._instructorGroupsData.value.map(g => g.offerings)));
  }
  get allInstructedSessions() {
    if (!this._instructorIlmSessionSessions?.isResolved || !this._instructorGroupIlmSessionSessions?.isResolved || !this._allInstructedOfferingSessions.isResolved) {
      return [];
    }
    return uniqueValues([...this._instructorIlmSessionSessions.value, ...this._instructorGroupIlmSessionSessions.value, ...this._allInstructedOfferingSessions.value].filter(Boolean));
  }
  get _allInstructedCoursesData() {
    if (!this._instructorIlmSessionSessions?.isResolved || !this._instructorGroupIlmSessionSessions?.isResolved || !this._allInstructedOfferingSessions.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(uniqueValues([...this._instructorIlmSessionSessions.value, ...this._instructorGroupIlmSessionSessions.value, ...this._allInstructedOfferingSessions.value].filter(Boolean).map(s => s.course))));
  }
  get allInstructedCourses() {
    if (!this._allInstructedCoursesData?.isResolved) {
      return [];
    }
    return this._allInstructedCoursesData.value;
  }
  get _learnerIlmSessionSessionsData() {
    if (!this._learnerIlmSessionsData.isResolved) {
      return [];
    }
    return new TrackedAsyncData(Promise.all(this._learnerIlmSessionsData.value.map(i => i.session)));
  }
  get _learnerGroupOfferingsData() {
    if (!this._learnerGroupsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._learnerGroupsData.value.map(l => l.offerings)));
  }
  get _learnerGroupIlmSessionsData() {
    if (!this._learnerGroupsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._learnerGroupsData.value.map(l => l.ilmSessions)));
  }
  get _learnerSessionsData() {
    if (!this._offeringsData.isResolved || !this._learnerIlmSessionsData.isResolved || !this._learnerGroupOfferingsData?.isResolved || !this._learnerGroupIlmSessionsData.isResolved) {
      return null;
    }
    const offerings = this._offeringsData.value;
    const learnerIlmSessions = this._learnerIlmSessionsData.value;
    const learnerGroupOfferings = this._learnerGroupOfferingsData.value.flat();
    const ilmSessions = this._learnerGroupIlmSessionsData.value.flat();
    return new TrackedAsyncData(Promise.all([...offerings, ...learnerIlmSessions, ...learnerGroupOfferings, ...ilmSessions].map(obj => obj.session)));
  }
  get _learnerCoursesData() {
    if (!this._learnerSessionsData?.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._learnerSessionsData.value.map(s => s.course)));
  }
  get allRelatedCourses() {
    if (!this._learnerCoursesData?.isResolved || !this._allInstructedCoursesData?.isResolved || !this._directedCoursesData.isResolved || !this._administeredCoursesData.isResolved) {
      return [];
    }
    return uniqueValues([...this._learnerCoursesData.value, ...this._allInstructedCoursesData.value, ...this._directedCoursesData.value, ...this._administeredCoursesData.value]);
  }
  get secondaryCohorts() {
    if (!this._cohortsData.isResolved || !this._primaryCohortData.isResolved) {
      return [];
    }
    return this._cohortsData.value.filter(cohort => cohort !== this._primaryCohortData.value);
  }

  /**
   * Compare a user's learner groups to a list of learner groups and find the one
   * that is the lowest leaf in the learner group tree.
   * @property getLowestMemberGroupInALearnerGroupTree
   * @param {Array} learnerGroupTree all the groups we want to look into
   * @return {Object|null} The learner-group model or NULL if none could be found.
   * @type function
   * @public
   */
  async getLowestMemberGroupInALearnerGroupTree(learnerGroupTree) {
    const learnerGroups = await this.learnerGroups;
    //all the groups a user is in that are in our current learner groups tree
    const relevantGroups = learnerGroups.filter(group => learnerGroupTree.includes(group));
    const relevantGroupIds = mapBy(relevantGroups, 'id');
    const lowestGroup = relevantGroups.find(group => {
      const childIds = group.hasMany('children').ids();
      const childGroupsWhoAreUserGroupMembers = childIds.filter(id => relevantGroupIds.includes(id));
      return childGroupsWhoAreUserGroupMembers.length === 0;
    });
    return lowestGroup ? lowestGroup : null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "lastName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "firstName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "middleName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "displayName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pronouns", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phone", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "email", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "preferredEmail", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "addedViaIlios", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "enabled", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "campusId", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "otherId", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "examined", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "userSyncIgnore", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "icsFeedKey", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "root", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "reports", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "school", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "authentication", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "directedCourses", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "administeredCourses", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "studentAdvisedCourses", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "studentAdvisedSessions", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "learnerGroups", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "instructedLearnerGroups", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "instructorGroups", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "instructorIlmSessions", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "learnerIlmSessions", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "offerings", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "instructedOfferings", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "programYears", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "roles", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "directedSchools", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "administeredSchools", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "administeredSessions", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "directedPrograms", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "cohorts", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "primaryCohort", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "pendingUserUpdates", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "administeredCurriculumInventoryReports", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "sessionMaterialStatuses", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_rolesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_rolesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_cohortsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_cohortsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_offeringsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_offeringsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_learnerIlmSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnerIlmSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_directedCoursesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_directedCoursesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_administeredCoursesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_administeredCoursesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_administeredSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_administeredSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructorGroupsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorGroupsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructedOfferingsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructedOfferingsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructedLearnerGroupsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructedLearnerGroupsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_directedProgramsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_directedProgramsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_programYearsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_programYearsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_administeredCurriculumInventoryReportsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_administeredCurriculumInventoryReportsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_directedSchoolsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_directedSchoolsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_administeredSchoolsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_administeredSchoolsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructorIlmSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorIlmSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_primaryCohortData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_primaryCohortData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_learnerGroupsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnerGroupsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructedLearnerGroupOfferingsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructedLearnerGroupOfferingsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_allInstructedOfferingSessions", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_allInstructedOfferingSessions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructorIlmSessionSessions", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorIlmSessionSessions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructorGroupIlmSessions", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorGroupIlmSessions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructorGroupIlmSessionSessions", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorGroupIlmSessionSessions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructorGroupOfferings", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorGroupOfferings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_allInstructedCoursesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_allInstructedCoursesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_learnerIlmSessionSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnerIlmSessionSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_learnerGroupOfferingsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnerGroupOfferingsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_learnerGroupIlmSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnerGroupIlmSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_learnerSessionsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnerSessionsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_learnerCoursesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnerCoursesData"), _class.prototype), _class);
export { User as default };